
define('text!templates/appMain/privilegedMain/qm/policies/editors/textEditor.html',[],function () { return '<input type="text" class="form-control" data-bind="value: valueText">\n';});

